import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { Box, CircularProgress } from '@mui/material';
import { useAuth } from '../context/AuthContext'; // Use the central context

const AuthGuard = ({ children }) => {
    const { user, isLoading, isUnassigned } = useAuth();
    const location = useLocation();

    // While the context is loading the initial user data, show a spinner.
    if (isLoading) {
        return (
            <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100vh' }}>
                <CircularProgress />
            </Box>
        );
    }

    if (!user) {
        if (location.pathname !== '/login') {
            sessionStorage.setItem('redirectAfterLogin', location.pathname);
        }
        return <Navigate to="/login" replace />;
    }

    if (isUnassigned) {
        return <Navigate to="/access-denied" replace />;
    }

    // If loading is done and we have a user, render the protected application.
    return children;
};

export default AuthGuard;